import React, { useRef, useEffect } from "react";
import moment from "moment";

const ViewModal = ({ isOpen, onClose, data, field }) => {
  const modalRef = useRef(null);

  // Extract API data safely
  const showData = data?.data || {};

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isOpen, onClose]);
const getReadableType = (type) => {
  switch (type) {
    case "notify_all":
      return "Notify All";
    case "notify_all_users":
      return "Notify All Users";
    case "notify_all_members":
      return "Notify All Members";
    case "selected_users":
      return "Selected Users";
    case "selected_members":
      return "Selected Members";
    default:
      return type || "-";
  }
};
  return (
    <>
      {isOpen && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            ref={modalRef}
            style={{ minWidth: "45%" }}
          >
            <div className="modal-content">
              {/* HEADER */}
              <div className="modal-header">
                <h5 className="modal-title" style={{ fontSize: "22px" }}>
                  {field.title}
                </h5>
                <button type="button" className="btn-close" onClick={onClose} />
              </div>

              {/* BODY */}
              <div className="modal-body" style={{ maxHeight: "65vh", overflowY: "auto" }}>
                {/* TITLE */}
                
                {/* MESSAGE */}
                {/* <div className="mb-3">
                  <label className="form-label">
                    <b>{field.message}:</b>
                  </label>
                  <div className="form-control">{showData.body}</div>
                </div> */}

                     <div className="mb-2">
                    <b>Title:</b> {showData?.title || "-"}
                    </div>

                    {/* MESSAGE */}
                    <div className="mb-2">
                    <b>Message:</b> {showData?.body || "-"}
                    </div>

                    {/* TYPE */}
                    <div className="mb-2">
                    <b>Notification Type:</b> {getReadableType(showData.for_user_type)}
                    </div>

                    {/* DATE */}
                    <div className="mb-2">
                    <b>Date:</b> {moment(showData?.createdAt).format("DD-MM-YYYY HH:mm")}
                    </div>

                {/* SENDER LIST (SCROLLABLE AREA) */}
                {/* SENDER LIST (ONE-LINE DISPLAY + READ STATUS) */}
{showData.sendUserData && showData.sendUserData.length > 0 && (
  <div className="mb-3">
    <label className="form-label">
      <b>{field.senderData}:</b>
    </label>

    <div
      className="form-control"
      style={{
        maxHeight: "200px",
        overflowY: "auto",
        padding: "10px",
      }}
    >
      {showData.sendUserData.map((item, idx) => {
        const user = item?.UserInformation;

        return (
          <div
            key={idx}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 0",
              borderBottom: "1px solid #eee",
              fontSize: "14px",
            }}
          >
            {/* LEFT SIDE — USER INFO */}
            <div>
              <span><b>ID:</b> {user?.id}</span>
              {"  |  "}
              <span><b>Name:</b> {user?.first_name +" "+ user?.last_name}</span>
              {"  |  "}
              <span><b>Email:</b> {user?.email}</span>
            </div>

            {/* RIGHT SIDE — READ STATUS */}
            <div>
              {item.is_read === 1 ? (
                <span
                  style={{
                    padding: "3px 10px",
                    background: "#d4edda",
                    color: "#155724",
                    borderRadius: "5px",
                    fontSize: "12px",
                  }}
                >
                  Read
                </span>
              ) : (
                <span
                  style={{
                    padding: "3px 10px",
                    background: "#f8d7da",
                    color: "#721c24",
                    borderRadius: "5px",
                    fontSize: "12px",
                  }}
                >
                  Unread
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  </div>
)}
              </div>

              {/* FOOTER */}
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={onClose}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isOpen && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default ViewModal;
